import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { TMSCarrier } from 'types/Load';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

type GetCarriersResponse = {
  carrierList: TMSCarrier[];
  tmsTenant: string;
  preferredCarrierExternalTMSID?: string;
  message?: string;
};

export async function getCarriers(
  tmsID: number,
  forceRefresh?: boolean,
  customerID?: string
): Promise<Result<GetCarriersResponse, ApiError>> {
  try {
    const queryParams = new URLSearchParams({
      tmsID: String(tmsID),
    });
    if (forceRefresh) {
      queryParams.append('forceRefresh', 'true');
    }
    if (customerID) {
      queryParams.append('customerExternalTmsId', customerID);
    }

    const response = await axios.get<GetCarriersResponse>(
      `/carriers?${queryParams.toString()}`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getCarriers' });

    if (!isAxiosError(error)) {
      return err({ message: 'Unable to fetch carriers from TMS.' });
    }

    return err({
      message:
        error.response?.data?.message || 'Unable to fetch carriers from TMS.',
      status: error.response?.status,
      level: error.response?.data?.level || error.response?.data?.errorLevel,
    });
  }
}
